import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './withAuthorization.module.scss';
import { bindActionCreators } from 'redux';
import authActions from '../../actions/authActions';

const NotAuthorized = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h2 className={styles.pageHeading}>
          <i className={`fas fa-ban ${styles.notFoundIcon}`} />
          Not Authorized
        </h2>
        <div className="row center-xs">
          <div className="col-xs-12">
            <h3>We're sorry, but you are not authorized to view this page.</h3>
          </div>
        </div>
      </div>
    </div>
  );
};
class index extends Component {
  userIsInRole = () => {
    return this.props.userRoles.some(
      r => this.props.authorizedRoles.indexOf(r.toLowerCase()) >= 0
    );
  };

  render() {
    if (!this.props.user) {
      return null; //user not loaded yet, render nothing
    }
    if (this.userIsInRole()) {
      return this.props.children;
    }
    if (this.props.warnUser) {
      return <NotAuthorized />;
    }
    return null; //not authorized no warning
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...authActions }, dispatch);

const mapStateToProps = state => ({
  user: state.oidc.user,
  userRoles: state.auth.userRoles.map(role => role.roleName.toLowerCase()),
});

export default connect(mapStateToProps, mapDispatchToProps)(index);
